<template>
    <div>
        <!-- Snackbar -->
        <v-snackbar v-model="snackbar" top :color="color" :timeout="6000">
            <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card>
            <v-card-title class="toolbar">
                Transport Learner Attendance Report
            </v-card-title>

            <v-card-text>
                <v-row justify="center" class="mt-2">
                    <!-- Section -->
                    <v-col cols="12" sm="6" md="3">
                        <v-autocomplete v-model="selected_section" :items="selection_list" item-text="name"
                            item-value="id" outlined multiple rounded required @change="getStandard">
                            <template #label>
                                Section<span style="color: red;">*</span>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index === 0">
                                    <span>{{ item.name }}</span>
                                </v-chip>
                                <span v-if="index === 1" class="grey--text text-caption">
                                    (+{{ selected_section.length - 1 }} others)
                                </span>
                            </template>
                            <template v-slot:prepend-item>
                                <v-list-item @mousedown.prevent>
                                    <v-list-item-action>
                                        <v-checkbox v-model="selected_all_section" @change="toggle_section"
                                            color="primary">
                                            <template #label>
                                                <span class="ml-8">Select All</span>
                                            </template>
                                        </v-checkbox>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                        </v-autocomplete>
                    </v-col>

                    <!-- Standard -->
                    <v-col cols="12" sm="6" md="3">
                        <v-autocomplete v-model="selected_standard" :items="standard_list" item-text="standard"
                            @change="getDivision" item-value="id" outlined multiple rounded required>
                            <template #label>
                                Standard<span style="color: red;">*</span>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index < 3">
                                    <span>{{ item.standard }}</span>
                                </v-chip>
                                <span v-if="index === 3" class="grey--text text-caption">
                                    (+{{ selected_standard.length - 3 }} others)
                                </span>
                            </template>
                            <template v-slot:prepend-item>
                                <v-list-item @mousedown.prevent>
                                    <v-list-item-action>
                                        <v-checkbox v-model="selected_all_standard" @change="toggle_standard">
                                            <template #label>
                                                <span class="ml-8">Select All</span>
                                            </template>
                                        </v-checkbox>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                        </v-autocomplete>
                    </v-col>

                    <!-- Division -->
                    <v-col cols="12" sm="6" md="3">
                        <v-autocomplete v-model="selected_div" :items="division_list" item-text="division"
                            item-value="id" outlined multiple rounded required>
                            <template #label>
                                Division<span style="color: red;">*</span>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index === 0">
                                    <span>{{ item.division }}</span>
                                </v-chip>
                                <span v-if="index === 1" class="grey--text text-caption">
                                    (+{{ selected_div.length - 1 }} others)
                                </span>
                            </template>
                            <template v-slot:prepend-item>
                                <v-list-item @mousedown.prevent>
                                    <v-list-item-action>
                                        <v-checkbox v-model="selected_all_division" @change="toggle_division">
                                            <template #label>
                                                <span class="ml-8">Select All</span>
                                            </template>
                                        </v-checkbox>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                        </v-autocomplete>
                    </v-col>
                </v-row>
                <v-row justify="center" align="center">
                    <v-col cols="12" sm="3" md="2">
                        <v-checkbox v-model="selected_transport_in" color="primary">
                            <template #label>
                                Transport-In<span style="color: red;">*</span>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="3" md="2">
                        <v-checkbox v-model="selected_transport_out" color="primary">
                            <template #label>
                                Transport-Out<span style="color: red;">*</span>
                            </template>
                        </v-checkbox>
                    </v-col>
                </v-row>
                <v-row justify="center" align="center">
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field v-model="selected_from_date" rounded outlined type="date">
                            <template #label>
                                From date<span style="color: red;">*</span>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field v-model="selected_to_date" rounded outlined type="date">
                            <template #label>
                                To date<span style="color: red;">*</span>
                            </template>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row justify="center" align="center">
                    <v-btn rounded class="button" :loading="loader" @click="getAllReport">
                        Fetch
                    </v-btn>
                </v-row>
            </v-card-text>
            <div v-if="attendanceList.length != 0" id="my-table-id" class="ma-3">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Transport Learner Attendance Report</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field class="pr-5 no-display" background-color="white" v-model="search"
                        append-icon="mdi-magnify" label="Search by Student Name or Registration Number" single-line
                        hide-details></v-text-field>
                    <v-btn small class="mr-5" color="success" @click="generateAttendancePdf" :loading="loader">
                        <v-icon small color="white">mdi-file-pdf-box</v-icon>
                        <span class="btn-text">PDF</span>
                    </v-btn>
                    <v-btn small color="success" @click="exportAttendanceData" :loading="loader">
                        <v-icon small color="white">mdi-export</v-icon>
                        <span class="btn-text">Export</span>
                    </v-btn>
                </v-toolbar>
                <v-data-table class="elevation-1 mytable" :headers="computedHeaders" :items="filteredAttendanceList"
                    :items-per-page="10" dense>
                    <!-- Custom row template -->
                    <template v-slot:item="{ item, index }">
                        <tr :class="{ 'highlight-row': item.isMismatch }">
                            <td>{{ index + 1 }}</td>
                            <td>{{ item.prn }}</td>
                            <td>{{ item.student_name }}</td>
                            <td>{{ item.standard }}</td>
                            <td>{{ item.division }}</td>
                            <td>{{ item.mapped_route_no }}</td>
                            <td>{{ item.mapped_vehicle_no }}</td>
                            <td>{{ item.attendance_date ? new Date(item.attendance_date).toLocaleDateString('en-GB') :
                                '--' }}</td>
                            <td v-if="selected_transport_in">{{ item.in_route }}</td>
                            <td v-if="selected_transport_in">{{ item.in_vehicle_no }}</td>
                            <td v-if="selected_transport_in">{{ formatTime(item.in_time) }}</td>
                            <td v-if="selected_transport_in">{{ item.inby || '--' }}</td>
                            <td v-if="selected_transport_in">{{ item.in_remark }}</td>
                            <td v-if="selected_transport_out">{{ item.out_route }}</td>
                            <td v-if="selected_transport_out">{{ item.out_vehicle_no }}</td>
                            <td v-if="selected_transport_out">{{ formatTime(item.out_time) }}</td>
                            <td v-if="selected_transport_out">{{ item.outby || '--' }}</td>
                            <td v-if="selected_transport_out">{{ item.out_remark }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </div>
            <div v-else class="ma-3">
                <v-alert type="info" outlined>
                    No attendance data available. Please fetch the report or check your filters.
                </v-alert>
            </div>
        </v-card>
        <v-container></v-container>
    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css";
    import jsPDF from "jspdf";
    import "jspdf-autotable";

    export default {
        data() {
            return {
                loader: false,
                color: "",
                snackbar: false,
                snackbar_msg: null,
                selected_div: [],
                selected_section: [],
                selected_standard: [],
                selected_transport_in: true,
                selected_transport_out: true,
                selected_from_date: new Date().toISOString().slice(0, 10),
                selected_to_date: new Date().toISOString().slice(0, 10),
                selected_all_section: true,
                selected_all_division: true,
                selected_all_standard: true,
                search: null,
                selection_list: [],
                standard_list: [],
                division_list: [],
                attendanceList: []
            };
        },

        mounted() {
            this.onload();
        },

        computed: {
            computedHeaders() {
                let baseHeaders = [
                    { text: "Sr. No.", value: "srno", sortable: false },
                    { text: "PRN", value: "prn" },
                    { text: "Student Name", value: "student_name" },
                    { text: "Standard", value: "standard" },
                    { text: "Division", value: "division" },
                    { text: "Mapped Route No", value: "mapped_route_no" },
                    { text: "Mapped Vehicle No", value: "mapped_vehicle_no" },
                    { text: "Date", value: "attendance_date" },
                ];
                if (this.selected_transport_in) {
                    baseHeaders.push({ text: "In Route No", value: "in_route" });
                    baseHeaders.push({ text: "In Vehicle No", value: "in_vehicle_no" });
                    baseHeaders.push({ text: "In Time", value: "in_time" });
                    baseHeaders.push({ text: "In By", value: "inby" });
                    baseHeaders.push({ text: "In Remark", value: "in_remark" });
                }
                if (this.selected_transport_out) {
                    baseHeaders.push({ text: "Out Route No", value: "out_route" });
                    baseHeaders.push({ text: "Out Vehicle No", value: "out_vehicle_no" });
                    baseHeaders.push({ text: "Out Time", value: "out_time" });
                    baseHeaders.push({ text: "Out By", value: "outby" });
                    baseHeaders.push({ text: "Out Remark", value: "out_remark" });
                }
                return baseHeaders;
            },

            filteredAttendanceList() {
                const filteredList = this.attendanceList
                    .filter(item => {
                        if (
                            this.search &&
                            !(
                                (item.prn && item.prn.toLowerCase().includes(this.search.toLowerCase())) ||
                                (item.student_name && item.student_name.toLowerCase().includes(this.search.toLowerCase()))
                            )
                        ) {
                            return false;
                        }
                        if (this.selected_transport_in && this.selected_transport_out) {
                            return true;
                        }
                        if (this.selected_transport_in && !this.selected_transport_out) {
                            return !!item.in_time;
                        }
                        if (!this.selected_transport_in && this.selected_transport_out) {
                            return !!item.out_time;
                        }
                        return false;
                    })
                    .map(item => {
                        const inRoute = item.in_route != null ? String(item.in_route).trim() : "";
                        const outRoute = item.out_route != null ? String(item.out_route).trim() : "";
                        const mappedRoute = item.mapped_route_no != null ? String(item.mapped_route_no).trim() : "";
                        const isMismatch = (inRoute && inRoute !== mappedRoute) || (outRoute && outRoute !== mappedRoute);
                        return { ...item, isMismatch };
                    });
                return filteredList;
            },
        },

        methods: {
            async getAllReport() {
                this.loader = true;
                this.attendanceList = [];
                const payload = {
                    selected_div: this.selected_div,
                    selected_section: this.selected_section,
                    selected_standard: this.selected_standard,
                    selected_transport_in: this.selected_transport_in,
                    selected_transport_out: this.selected_transport_out,
                    selected_from_date: this.selected_from_date,
                    selected_to_date: this.selected_to_date,
                };
                const res = await axios.post("/TransportLearnerAttendance/getTransportLearnerAttendance", payload);
                console.log("API Response:", res.data);
                if (res.data.msg === "200") {
                    this.attendanceList = res.data.attendanceList;
                    this.loader = false;
                } else {
                    this.loader = false;
                    this.showSnackbar("error", res.data.msg || "Failed to fetch report");
                }
            },

            formatTime(value) {
                if (!value) return "";
                const date = new Date(value);
                return date.toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true
                });
            },

            generateAttendancePdf() {
                try {
                    const headersArr = this.computedHeaders;
                    const headerTexts = headersArr.map(h => h.text);

                    // Map data for export
                    const exportData = this.filteredAttendanceList.map((item, index) => {
                        const row = {};
                        headersArr.forEach(h => {
                            if (h.value === "srno") {
                                row[h.value] = index + 1;
                            } else if (h.value === "attendance_date") {
                                row[h.value] = item[h.value]
                                    ? new Date(item[h.value]).toLocaleDateString("en-GB")
                                    : "-";
                            } else if (h.value === "in_time" || h.value === "out_time") {
                                row[h.value] = item[h.value]
                                    ? new Date(item[h.value]).toLocaleTimeString("en-US", {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: true
                                    })
                                    : "--";
                            } else {
                                row[h.value] = (item[h.value] !== undefined && item[h.value] !== null)
                                    ? item[h.value]
                                    : "--";
                            }
                        });
                        return row;
                    });

                    // Initialize jsPDF in landscape mode
                    const doc = new jsPDF({ orientation: "landscape" });

                    const columns = headersArr.map(h => ({
                        header: h.text,
                        dataKey: h.value,
                    }));

                    // Define column widths (in mm)
                    const columnWidths = {
                        srno: 8,
                        prn: 18,
                        student_name: 25,
                        mapped_route_no: 20,
                        mapped_vehicle_no: 20,
                        in_route: 20,
                        out_route: 20,
                        in_vehicle_no: 20,
                        out_vehicle_no: 20,
                        standard: 12,
                        division: 10,
                        attendance_date: 15,
                        in_time: 15,
                        out_time: 15,
                        inby: 25,
                        outby: 25,
                        in_remark: 20,
                        out_remark: 20,
                    };

                    // A4 landscape width is ~297mm, with 10mm margins (usable ~277mm)
                    const totalWidth = Object.values(columnWidths).reduce((sum, width) => sum + width, 0);
                    const maxWidth = 277; // Usable width in landscape
                    const scaleFactor = totalWidth > maxWidth ? maxWidth / totalWidth : 1;

                    // Scale column widths if needed
                    const scaledColumnStyles = {};
                    Object.keys(columnWidths).forEach(key => {
                        scaledColumnStyles[key] = { cellWidth: columnWidths[key] * scaleFactor };
                    });

                    doc.autoTable({
                        theme: "grid",
                        columns: columns,
                        body: exportData,
                        margin: { top: 5, right: 5, bottom: 5, left: 5 },
                        styles: {
                            fontSize: 6, // Small font size for compactness
                            cellPadding: 0.5, // Minimal padding
                            overflow: "linebreak", // Allow text to wrap naturally
                            halign: "center", // Center-align text
                            valign: "middle", // Middle-align text
                        },
                        columnStyles: scaledColumnStyles,
                        headStyles: {
                            fillColor: [0, 128, 0],
                            textColor: [255, 255, 255],
                            fontSize: 5, // Smaller header font
                            cellPadding: 0.5, // Minimal padding in header
                            halign: "center",
                            valign: "middle",
                        },
                        didParseCell: (data) => {
                            // Ensure text wraps and cell height adjusts
                            data.cell.styles.lineWidth = 0.1; // Thinner borders for clarity
                        },
                        didDrawCell: (data) => {
                            // Optional: Adjust cell height dynamically if needed
                            if (data.cell.text && data.cell.text.length > 0) {
                                const textHeight = doc.getTextDimensions(data.cell.text.join(" "), {
                                    fontSize: data.cell.styles.fontSize,
                                }).h;
                                if (textHeight > data.cell.height) {
                                    data.cell.height = textHeight + data.cell.styles.cellPadding * 2;
                                }
                            }
                        },
                    });

                    doc.save("TransportAttendanceReport.pdf");
                } catch (err) {
                    console.error("PDF generation error:", err);
                    this.showSnackbar("error", "Failed to generate attendance PDF");
                }
            },
            exportAttendanceData() {
                try {
                    const headersArr = this.computedHeaders;
                    const headerTexts = headersArr.map(h => h.text);
                    const exportData = this.filteredAttendanceList.map((item, index) => {
                        const row = {};
                        headersArr.forEach(h => {
                            if (h.value === "srno") {
                                row[h.text] = index + 1;
                            } else if (h.value === "attendance_date") {
                                row[h.text] = item[h.value]
                                    ? new Date(item[h.value]).toLocaleDateString("en-GB")
                                    : "-";
                            } else if (h.value === "in_time" || h.value === "out_time") {
                                row[h.text] = item[h.value]
                                    ? new Date(item[h.value]).toLocaleTimeString("en-US", {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: true
                                    })
                                    : "-";
                            } else {
                                row[h.text] = (item[h.value] !== undefined && item[h.value] !== null)
                                    ? item[h.value]
                                    : "-";
                            }
                        });
                        return row;
                    });

                    import("xlsx").then(XLSX => {
                        const worksheet = XLSX.utils.json_to_sheet(exportData, { header: headerTexts });
                        const workbook = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance");
                        XLSX.writeFile(workbook, "Attendance_List.xlsx");
                    });
                } catch (err) {
                    console.error("Export error:", err);
                    this.showSnackbar("error", "Failed to export attendance data");
                }
            },

            toggle_section() {
                this.$nextTick(() => {
                    if (this.selected_all_section) {
                        this.selected_section = [];
                        for (var x in this.selection_list) {
                            this.selected_section.push(this.selection_list[x].id);
                        }
                        this.getStandard();
                    } else {
                        this.selected_section = [];
                    }
                    this.clear();
                });
            },

            toggle_standard() {
                this.$nextTick(() => {
                    if (this.selected_all_standard) {
                        this.selected_standard = [];
                        for (var x in this.standard_list) {
                            this.selected_standard.push(this.standard_list[x].id);
                        }
                        this.getDivision();
                    } else {
                        this.selected_standard = [];
                    }
                });
            },

            toggle_division() {
                this.$nextTick(() => {
                    if (this.selected_all_division) {
                        this.selected_div = [];
                        for (var x in this.division_list) {
                            this.selected_div.push(this.division_list[x].id);
                        }
                    } else {
                        this.selected_div = [];
                    }
                });
            },

            showSnackbar(color, msg) {
                this.snackbar = true;
                this.color = color;
                this.snackbar_msg = msg;
            },

            async onload() {
                const res = await axios.post("/TransportLearnerAttendance/getSectionlistAndDivision");
                if (res.data.msg === "200") {
                    this.selection_list = res.data.selection_list;
                    this.toggle_section();
                } else {
                    this.showSnackbar("error", res.data.msg || "Failed to load data");
                }
            },

            async getStandard() {
                this.clear();
                const data = { selected_section: this.selected_section };
                const res = await axios.post("/TransportLearnerAttendance/getStandardLiatFromSection", data);
                if (res.data.msg == "200") {
                    this.standard_list = res.data.standard_list;
                    this.toggle_standard();
                } else {
                    this.showSnackbar("red", res.data.msg);
                }
            },

            async getDivision() {
                const data = { selected_standard: this.selected_standard };
                const res = await axios.post("/TransportLearnerAttendance/getDivisionLiatFromStandard", data);
                if (res.data.msg == "200") {
                    this.division_list = res.data.division_list;
                    this.toggle_division();
                } else {
                    this.showSnackbar("red", res.data.msg);
                }
            },

            clear() {
                this.division_list = [];
                this.selected_div = [];
                this.standard_list = [];
                this.selected_standard = [];
            },
        },
    };
</script>

<style>
    /* Temporarily non-scoped for debugging */
    @media (max-width: 600px) {
        .btn-text {
            display: none;
            padding: 0px;
        }
    }

    .v-data-table>.v-data-table__wrapper>table>tbody>tr.highlight-row {
        background-color: #B2EBF2 !important;
        /* Red background for mismatched routes */
        color: #FFFFFF !important;
        /* White text for contrast */
        border: 2px solid #B2EBF2 !important;
        /* Red border */
    }

    .v-data-table .highlight-row {
        background-color: #B2EBF2 !important;
        /* Red background for mismatched routes */
        color: #FFFFFF !important;
        /* White text for contrast */
        border: 2px solid #B2EBF2 !important;
        /* Red border */
    }
</style>